import React from 'react';

import { BlockType } from '../../types/apiEnums';
import {
  FullWidthBlocksPresentational,
  TitleBodyImageBlockPresentational,
  TitleBodyImageLinkBlockPresentational,
} from '../../types/common';
import { ContentBlock } from '../ContentBlock/ContentBlock';
import styles from './ContentBlocksSection.module.css';

export type Props = {
  isDesktop: boolean;
  items: FullWidthBlocksPresentational[];
};

export const ContentBlocksSection = React.memo((props: Props) => {
  const { items, isDesktop } = props;

  return items?.length ? (
    <div className={styles.contentBlocksSection}>
      <div className={styles.contentBlocksSectionInner}>
        <div className={styles.items}>
          {items.map((item, key) => (
            <ContentBlock
              key={`content-block-${key}`}
              isDesktop={isDesktop}
              className={
                item.blockType === BlockType.TITLE_BODY_IMAGE_LINK
                  ? styles.imagesAlternation
                  : undefined
              }
              body={item.body}
              title={item.title}
              image={(item as TitleBodyImageBlockPresentational).image || null}
              link={(item as TitleBodyImageLinkBlockPresentational).link || null}
            />
          ))}
        </div>
      </div>
    </div>
  ) : null;
});

ContentBlocksSection.displayName = 'ContentBlocksSection';
